import { Action } from './type'

export type StatusesAction = Action & {
  type: 'SUCCESS_FETCH_STATUSES'
}

export type StatusesResponse = {
  statuses: {
    id: number
    name: string
    color: string
  }[]
}

export const FETCH_STATUSES = 'FETCH_STATUSES'
export function fetchStatuses() {
  return { type: FETCH_STATUSES }
}

export const SUCCESS_FETCH_STATUSES = 'SUCCESS_FETCH_STATUSES'
export function successFetchStatuses(statuses: StatusesResponse) {
  return { type: SUCCESS_FETCH_STATUSES, payload: statuses }
}

export const FAILED_FETCH_STATUSES = 'FAILED_FETCH_STATUSES'
export function failedFetchStatuses(message: string) {
  console.log('Error: FAILURE_DOWNLOAD ', message)
  return { type: FAILED_FETCH_STATUSES }
}

export const statusesActions = {
  fetchStatuses,
  successFetchStatuses,
  failedFetchStatuses,
}
